import React, { useState } from 'react';
import Seo from '../components/common/Seo';
import AboutHero from '../components/about/AboutHero';
import WhyJoinAgastya from '../components/career/WhyJoinAgastya';
import CurrentOpenings from '../components/career/CurrentOpenings';
import OurCulture from '../components/career/OurCulture';
import Benefits from '../components/career/Benefits';
import JobApplicationForm from '../components/career/JobApplicationForm';
import join_our_team from '../assets/images/join_our_team.webp';

const Career = () => {
    const [isFormOpen, setIsFormOpen] = useState(false);
    const [selectedJob, setSelectedJob] = useState(null);

    const handleOpenForm = (jobData) => {
        setSelectedJob(jobData);
        setIsFormOpen(true);
    };

    const handleCloseForm = () => {
        setIsFormOpen(false);
        setSelectedJob(null);
    };

    return (
        <div className="w-full">
            <Seo
                title="Careers at Agastya Agro | Build Impactful Agri Work"
                description="Explore open roles at Agastya Agro and grow your career while helping deliver smarter crop protection to farmers nationwide."
            />
            {/* Hero Section with Component-based Design */}
            <AboutHero 
                heroImage={join_our_team}
                title="Join Agastya Agro's Team"
                subtitle="Join our Team"
            />
            
            <WhyJoinAgastya />
            <CurrentOpenings onApplyClick={handleOpenForm} />
            <OurCulture />
            <Benefits />

            {/* Job Application Form at Career page level */}
            <JobApplicationForm 
                isOpen={isFormOpen} 
                onClose={handleCloseForm} 
                jobTitle={selectedJob?.title}
                description={selectedJob?.description}
            />
        </div>
    );
};

export default Career;